import { useNavigate } from 'react-router-dom';

const Redirect = (props) => {
  let navigate = useNavigate();
  function handleClick() {
    navigate(props.to);
  };

  if(props.redirect) handleClick()
  return <></>;
};

export default Redirect